import React from "react";
import PageLayout from "@/components/layouts/page/PageLayout";
import { useParams } from "react-router-dom";
import { emailCampaigns } from "../utils/emailCampaignsDummyData";
import EmailJoinCampaign from "../components/join-campaign/EmailJoinCampaign";
import BackLink from "@/components/BackLink";

function EmailCampaignJoinPage() {
  const { campaignId } = useParams();

  const campaign = emailCampaigns.find(
    (campaign) => campaign.id === parseInt(campaignId || "")
  );

  if (!campaign) {
    return <div>Campaign not found</div>;
  }

  return (
    <PageLayout className="participant-dashboard-container mx-0 mx-sm-2">
      <BackLink />
      <EmailJoinCampaign campaign={campaign} />
    </PageLayout>
  );
}

export default EmailCampaignJoinPage;
